import React, { useEffect, useState, useRef } from "react";
import success from "img/genai/checkbox.svg";
import styles from "styles/genai/Edetail.module.scss";
import { ProceedCMSD } from "./ProceedCMSD";
import {
  ElementPreviewSlides,
  AnalysePreviewSlides,
  GenarateCMSD,
} from "./PreviewSlides";
import { ModuleElementModal } from "./ModuleElementModal";
import {
  publishDynamicModule,
  removeElementFromModule,
  toggleMustUse,
  updateModule,
  deleteModule,
} from "services/apis";
import { renderToString } from "react-dom/server";
import ModulePreviewData from "components/modules/ModulePreviewData";
import { moduleActionTypes } from "contexts/ModuleContext";
import crossicon from "img/falsyicon.svg";
import {
  addElementsToModulePromise,
  createModulePromise,
} from "../api/genaimoduleapi";
import { createMultipleModules, updateModulePromise } from "../api/genapi";
import { toast } from "react-toastify";
import UnsuccessfulToastMessage from "components/UnsuccessfulToastMessage";
import SuccessfulToastMessage from "components/SuccessfulToastMessage";
import { classifySlideAssets } from "../api/genapi";
import { useHistory } from "react-router-dom";
import { routes } from "Uitls/Util";
import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";
import { useKeycloak } from "@react-keycloak/web";
import { MultiAnalysePreviewSlides } from "./sliderec/MultiAnalysePreviewSlides";
import {
  transformElementRationale,
  createPageIdToSlideMap,
  transformSelectedSlide,
} from "../utils/multiModHelpers";
import CircularProgressBar from "Uitls/CircularProgressBar";

import { GenaiLoader } from "../utils/GenaiLoader";
import SlideRecLoader from "../utils/SlideRecLoader";
import OneByFourLoader from "../utils/OneByFourLoader";
// Global cache for slide data to prevent duplicate API calls
const slideDataCache = {};
// Global cache for moduleIds to persist them by slideId
const moduleIdCache = {};
// Expose the cache to window object for sharing across components
window.slideDataCache = slideDataCache;
window.moduleIdCache = moduleIdCache;
// GLOBAL CANCELLATION REGISTRY (add this at the top of the file, outside components)
const globalCancellationRegistry = {
  controllers: new Map(),
  cancelAll: function () {
    this.controllers.forEach((controller, messageId) => {
      controller.abort();
    });
    this.controllers.clear();
  },
  register: function (messageId, controller) {
    this.controllers.set(messageId, controller);
  },
  unregister: function (messageId) {
    this.controllers.delete(messageId);
  },
};
export const RetrivedSlide = ({
  modulesData,
  slideCount,
  messageId,
  selectedSlide,
  countryNameUI,
  messages,
  userCollectedMeta,
  multiModules,
  generatemultimodBtn,
  setTextShow,
  moduleGenerate,
  cancelbtn,
  cancelAbort,
  triggerMulti,
  restartMod,
  startAssembly,
  greyOld,
  startNew,
}) => {
  const loadElementsTimeoutRef = useRef(null);
  const { generateMultiMod, setGenerateMultiMod } = generatemultimodBtn;
  const { goforGenerate, setGoforGenerate } = moduleGenerate;
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const listContentRef = useRef(null);
  const { multiModuleCreation, setMultiModuleCreation } = multiModules;
  const userName = !!keycloak.authenticated ? keycloak.tokenParsed.name : null;
  const { showNewBubble, setShowNewBubble } = startNew;
  const [showCMSDFlow, setShowCMSDFlow] = useState(false);
  const [showModuleAssembly, setShowModuleAssembly] = useState(false);
  const [isBack, setIsBack] = useState(false);

  const [showElementModal, setShowElementModal] = useState(false);
  const [showAnalysetModal, setShowAnalyseModal] = useState(false);
  const [analyseModal, setAnalyseModal] = useState(false);
  // const [cmsdData, setShowCmsddata] = useState(false);
  const [showCMSD, setShowCmsd] = useState(false);
  const [sendCMSD, setSendCMSD] = useState(false);

  // Modal state
  const [totalModules, setTotalModules] = useState(0);
  const [currentModule, setCurrentModule] = useState(1);
  const [moduleMetadata, setModuleMetadata] = useState([]);
  const [processedSlideIds, setProcessedSlideIds] = useState({});

  // Store moduleIds for each slide
  const [moduleIds, setModuleIds] = useState({});
  // Current active moduleId (for the current module/slide)
  const [moduleId, setModuleId] = useState(null);
  const [moduleElements, setModuleElements] = useState({});
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showModuleElementModal, setShowModuleElementModal] = useState(false);
  const [showPublishConfirmModal, setShowPublishConfirmModal] = useState(false);
  const [modulesPublished, setModulesPublished] = useState(false);

  // Create a real selectedSlide object with proper data
  const [currentSelectedSlide, setCurrentSelectedSlide] = useState(null);

  const [noElementsWarningShown, setNoElementsWarningShown] = useState(false);
  const [edetailDetails, setEdetailDetails] = useState({});

  // Add state for multiple modules data - NOW SET FROM CHILD
  const [multipleModulesData, setMultipleModulesData] = useState([]);
  const [multiModulesLoading, setMultiModulesLoading] = useState(false);
  const [multiModulesError, setMultiModulesError] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const showAllPreview = { isPreviewOpen, setIsPreviewOpen };
  // Add these with other state declarations:
  const [selectedModules, setSelectedModules] = useState([]);
  const [createdModules, setCreatedModules] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [missingMetadataModules, setMissingMetadataModules] = useState([]);
  const [showMissingMetadataPopup, setShowMissingMetadataPopup] =
    useState(false);

  const [permanentlyGreyedOutIds, setPermanentlyGreyedOutIds] = useState([]);
  const { cancelGenerate, setCancelGenerate } = cancelbtn;
  const { abortModules, setAbortModules } = cancelAbort;
  const { triggerModuleGeneration, setTriggerModuleGeneration } = triggerMulti;
  const { restartModules, setRestartModules } = restartMod;
  const { assemblyshow, setAssemblyshow } = startAssembly;
  const { gryRetrivedSlideIds, setGryRetrivedSlideIds } = greyOld;
  const [originalModuleMetadata, setOriginalModuleMetadata] = useState({});
  const [modalCompleted, setModalCompleted] = useState({
    elementModal: false,
    analyseModal: false,
    moduleAssembly: false,
    cmsdModal: false,
  });
  const isLatestMessage =
    messages.filter((msg) => msg.responseType === "fullslide").slice(-1)[0]
      ?.id === messageId;
  // Update the main useEffect that triggers the API call
  const abortControllerRef = useRef(null);
  const isCancelledRef = useRef(false);
  const [cancelButtonKey, setCancelButtonKey] = useState(0);

  // Initialize button states on mount
  useEffect(() => {
    // Ensure textShow is true initially for cancel button condition
    if (setTextShow) {
      setTextShow(true);
    }

    // Ensure cancel button is hidden initially
    if (setCancelGenerate) {
      setCancelGenerate(false);
    }

    return () => {
      // Cleanup
      if (setTextShow) setTextShow(true);
    };
  }, [setTextShow, setCancelGenerate, setGenerateMultiMod, setGoforGenerate]);

  useEffect(() => {
    let isCancelling = false;
    let cancelHandlerTimeout = null;

    const executeCancellation = () => {
      if (isCancelling) return;
      isCancelling = true;

      // 1. Cancel all API calls
      globalCancellationRegistry.cancelAll();

      // 2. Reset local states
      setShowModuleAssembly(false);
      setMultipleModulesData([]);
      setMultiModulesLoading(false);
      setMultiModulesError(null);

      // 3. RESET BUTTON STATES - Order matters!
      // First, hide cancel button and ensure text shows
      if (setCancelGenerate) {
        setCancelGenerate(false); // Hide cancel button
      }

      if (setTextShow) {
        setTextShow(true); // Show text (required for cancel button condition)
      }

      // Small delay to ensure above states are set
      setTimeout(() => {
        // Then show other buttons
        if (setGenerateMultiMod) {
          setGenerateMultiMod(true); // Show multi-module button
        }

        if (setGoforGenerate) {
          setGoforGenerate(true); // Show generate button
        }

        // Force cancel button re-render
        setCancelButtonKey((prev) => prev + 1);

        // Reset trigger
        setTriggerModuleGeneration(false);

        isCancelling = false;
      }, 50);

      // 4. Reset abort flag after a delay
      setTimeout(() => {
        if (setAbortModules) {
          setAbortModules(false);
        }
      }, 150);
    };

    if (abortModules === true) {
      // Clear any existing timeout
      if (cancelHandlerTimeout) {
        clearTimeout(cancelHandlerTimeout);
      }

      // Debounce the cancellation to prevent rapid triggers
      cancelHandlerTimeout = setTimeout(() => {
        executeCancellation();
      }, 50);
    }

    // Cleanup
    return () => {
      if (cancelHandlerTimeout) {
        clearTimeout(cancelHandlerTimeout);
      }
    };
  }, [
    abortModules,
    setTextShow,
    setCancelGenerate,
    setGoforGenerate,
    setGenerateMultiMod,
    setAbortModules,
  ]);

  // Single API call effect
  useEffect(
    function () {
      let apiCallActive = false;
      let abortController = null;
      let isMounted = true;

      function executeApiCall() {
        if (apiCallActive || !isMounted) return;

        const selectionKey = getSelectionKey();

        if (
          !triggerModuleGeneration ||
          !selectionKey ||
          !multiModuleCreation ||
          !isLatestMessage
        ) {
          return;
        }

        apiCallActive = true;

        abortController = new AbortController();
        globalCancellationRegistry.register(messageId, abortController);

        setMultipleModulesData([]);
        setMultiModulesError(null);
        setShowModuleAssembly(false);
        setMultiModulesLoading(true);
        setTextShow(true);
        setCancelGenerate(true);
        setGoforGenerate(false);
        setGenerateMultiMod(false);

        const transformedSlide = transformSelectedSlide(selectedSlide);
        const pageIdToSlideMap = createPageIdToSlideMap(transformedSlide);

        const lastMeta =
          userCollectedMeta && userCollectedMeta.length > 0
            ? userCollectedMeta[userCollectedMeta.length - 1]
            : {};
        const topic = lastMeta.topic || "";
        const objective = lastMeta.objective || "";

        // Use .then().catch().finally() - NO async/await
        createMultipleModules(
          transformedSlide.assetId,
          transformedSlide.slideIds,
          topic,
          objective,
          abortController.signal,
        )
          .then(function (response) {
            if (
              !isMounted ||
              abortController?.signal?.aborted ||
              abortModules === true
            ) {
              return;
            }

            if (response && Array.isArray(response) && response.length > 0) {
              const transformed = transformElementRationale(
                response,
                pageIdToSlideMap,
              );
              setMultipleModulesData(transformed);
              setShowModuleAssembly(true);
              setShowNewBubble(true);
              setTextShow(true);
            } else {
              setMultiModulesError("NO_MODULES_FOUND");
              setShowErrorModal(true);
            }
          })
          .catch(function (error) {
            if (!isMounted) return;

            // Check for cancellation
            if (
              error.message === "Request was cancelled" ||
              abortModules === true
            ) {
              return;
            }

            console.error("API Error:", error);
            setMultiModulesError("API_ERROR");
            setShowErrorModal(true);
            setShowModuleAssembly(false);
          })
          .finally(function () {
            if (isMounted) {
              setMultiModulesLoading(false);
              if (abortModules !== true) {
                setCancelGenerate(false);
              }
              setTriggerModuleGeneration(false);
              apiCallActive = false;
            }

            if (abortController) {
              globalCancellationRegistry.unregister(messageId);
            }
          });
      }

      executeApiCall();

      return function cleanup() {
        isMounted = false;
        apiCallActive = false;

        if (abortController) {
          abortController.abort();
          globalCancellationRegistry.unregister(messageId);
        }
      };
    },
    [triggerModuleGeneration],
  );

  useEffect(() => {
    // Only allow assemblyshow to trigger if NOT cancelled
    if (assemblyshow === true && abortModules !== true) {
      setMultiModuleCreation(false);
      setMultipleModulesData(false);
      setShowModuleAssembly(true);
      setShowNewBubble(true);
      setTextShow(true);
    }
    // If cancelled, override to false
    if (abortModules === true) {
      setShowModuleAssembly(false);
    }
  }, [assemblyshow, abortModules]);

  // Helper function to create a unique key for the current selection
  const getSelectionKey = () => {
    if (!selectedSlide) return null;
    return `${selectedSlide.assetId}-${selectedSlide.slideIds?.join(
      ",",
    )}-${multiModuleCreation}`;
  };

  // Add this useEffect in your RetrivedSlide component:

  // Add these handler functions before handleNext:
  const handleModuleSelectionChange = async (moduleIndex, isSelected) => {
    // IMMEDIATE UI UPDATE FIRST
    setSelectedModules((prev) => {
      const newSelected = [...prev];
      newSelected[moduleIndex] = isSelected;
      return newSelected;
    });
    if (isSelected) {
      // Navigate to the checked module
      setCurrentModule(moduleIndex + 1);
    }
    // If unchecking a created module, handle deletion
    if (!isSelected && createdModules[moduleIndex]) {
      let moduleIdToDelete = null;
      let moduleKey = null;

      if (multiModuleCreation) {
        moduleKey = `module_${moduleIndex + 1}`;
        moduleIdToDelete = moduleIds[moduleKey];
      } else {
        const slideId = selectedSlide?.slideIds?.[moduleIndex];
        if (slideId) {
          moduleIdToDelete = moduleIds[slideId];
          moduleKey = slideId;
        }
      }

      if (moduleIdToDelete) {
        // Call delete API
        deleteModule(moduleIdToDelete, (response, error) => {
          if (!error) {
            // Update state after successful deletion
            setModuleIds((prev) => {
              const newIds = { ...prev };
              if (moduleKey) delete newIds[moduleKey];
              return newIds;
            });

            setCreatedModules((prev) => {
              const newCreated = [...prev];
              newCreated[moduleIndex] = false;
              return newCreated;
            });
          } else {
            console.error("Error deleting module:", error);
            // If deletion fails, revert the checkbox state
            setSelectedModules((prev) => {
              const newSelected = [...prev];
              newSelected[moduleIndex] = true; // Re-check it
              return newSelected;
            });
          }
        });
      } else {
        // No module to delete, just update createdModules
        setCreatedModules((prev) => {
          const newCreated = [...prev];
          newCreated[moduleIndex] = false;
          return newCreated;
        });
      }
    }
    // If checking a module that wasn't created
    else if (isSelected && !createdModules[moduleIndex]) {
      // Ensure elements data is loaded for this module
      const moduleElementKey = moduleIndex + 1;

      if (multiModuleCreation && multipleModulesData[moduleIndex]) {
        // Load data for multi-module flow
        const moduleData = multipleModulesData[moduleIndex];
        const transformedData = transformApiDataToModuleFormat(moduleData);

        setModuleElements((prev) => ({
          ...prev,
          [moduleElementKey]: transformedData,
        }));
      } else if (!multiModuleCreation) {
        // For normal flow, ensure slide is processed
        const slideId = selectedSlide?.slideIds?.[moduleIndex];
        if (slideId) {
          setProcessedSlideIds((prev) => ({
            ...prev,
            [slideId]: false,
          }));
        }
      }
    }
  };

  const handleModuleNavigate = async (moduleIndex) => {
    if (
      moduleIndex >= 1 &&
      moduleIndex <= totalModules &&
      selectedModules[moduleIndex - 1]
    ) {
      // Check if we need to load elements for this module
      const moduleElementKey = moduleIndex;

      if (
        !moduleElements[moduleElementKey] ||
        Object.keys(moduleElements[moduleElementKey]).length === 0
      ) {
        if (multiModuleCreation) {
          // For multi-module flow
          // For multi-module flow
          if (multipleModulesData[moduleIndex - 1]) {
            const moduleData = multipleModulesData[moduleIndex - 1];
            // FIXED: Pass existing elements to preserve mustUse values
            const existingElements = moduleElements[moduleElementKey] || {};
            const transformedData = transformApiDataToModuleFormat(
              moduleData,
              existingElements,
            );

            setModuleElements((prev) => ({
              ...prev,
              [moduleElementKey]: transformedData,
            }));

            updateModuleMetadataFromApiResponse(
              moduleElementKey,
              transformedData,
            );
          }
        } else {
          // For normal flow
          const slideId = selectedSlide?.slideIds?.[moduleIndex - 1];
          // if (slideId) {
          //   await fetchModuleElements(moduleElementKey, slideId);
          // }
        }
      }

      setCurrentModule(moduleIndex);
    }
  };

  function transformSelectedSlide(selectedSlide) {
    if (
      !selectedSlide ||
      !selectedSlide.slideIds ||
      !selectedSlide.signedUrls
    ) {
      return selectedSlide;
    }

    const urlMap = Object.fromEntries(
      selectedSlide.signedUrls.map((url) => [url.pageId, url]),
    );

    const slideNumMap = Object.fromEntries(
      selectedSlide.slidenums?.map((num, index) => [
        selectedSlide.slideIds[index],
        num,
      ]) || [],
    );

    return {
      ...selectedSlide,
      slideIds: [...selectedSlide.slideIds], // Keep original order
      slidenums: selectedSlide.slideIds
        .map((id) => slideNumMap[id])
        .filter(Boolean),
      signedUrls: selectedSlide.slideIds
        .map((id) => urlMap[id])
        .filter(Boolean),
    };
  }
  // Move handleClear inside useEffect for clearing metadata states unlocked each time
  useEffect(() => {
    // console.log("Component mounted - running initial cleanup");

    // Clear local state
    setModuleId(null);
    setIsBack(false);
    setNoElementsWarningShown(false);
    setModuleElements({});
    setTotalModules(0);
    setCurrentModule(1);
    setModuleMetadata([]);
    setProcessedSlideIds({});

    setSelectedModules([]);
    setCreatedModules([]);
    // Clear all cached data to force API calls again
    if (selectedSlide) {
      // Use selectedSlide prop directly
      if (selectedSlide.assetId && selectedSlide.slideIds) {
        const clearedModuleIds = {};
        selectedSlide.slideIds.forEach((slideId) => {
          delete moduleIdCache[slideId];

          const cacheKey = getCacheKey(selectedSlide.assetId, slideId);
          delete slideDataCache[cacheKey];

          if (window.slideDataCache) delete window.slideDataCache[cacheKey];
          if (window.moduleIdCache) delete window.moduleIdCache[slideId];

          // console.log(`Cleared cache for slide ${slideId}`);
        });
        setModuleIds(clearedModuleIds);
      }

      if (selectedSlide.assetId && moduleIdCache[selectedSlide.assetId]) {
        delete moduleIdCache[selectedSlide.assetId];
        if (window.moduleIdCache)
          delete window.moduleIdCache[selectedSlide.assetId];
      }
    }

    // Set current selected slide

    const transformedSlide = transformSelectedSlide(selectedSlide);
    setCurrentSelectedSlide(transformedSlide);
  }, []);

  // Helper function to get the current slideId
  const getCurrentSlideId = () => {
    if (
      !currentSelectedSlide ||
      !currentSelectedSlide.slideIds ||
      currentModule <= 0 ||
      currentModule > currentSelectedSlide.slideIds.length
    ) {
      return null;
    }
    return currentSelectedSlide.slideIds[currentModule - 1];
  };

  // On component mount, make sure we're using the latest moduleIdCache
  useEffect(() => {
    // This ensures we're using the window's shared cache
    if (window.moduleIdCache) {
      Object.keys(window.moduleIdCache).forEach((key) => {
        if (!moduleIdCache[key]) {
          moduleIdCache[key] = window.moduleIdCache[key];
        }
      });
    }

    // When component unmounts, make sure window cache is updated
    return () => {
      window.moduleIdCache = { ...moduleIdCache };
    };
  }, []);

  // Initialize the currentSelectedSlide when component mounts or when selectedSlide prop changes
  useEffect(() => {
    if (selectedSlide) {
      const transformedSlide = transformSelectedSlide(selectedSlide);
      setCurrentSelectedSlide(transformedSlide);
      // setCurrentSelectedSlide(selectedSlide);

      // Initialize moduleIds from cache if available
      if (selectedSlide.slideIds && selectedSlide.slideIds.length > 0) {
        const initialModuleIds = {};

        // Check if we have cached moduleIds for any of the slides
        selectedSlide.slideIds.forEach((slideId, index) => {
          if (moduleIdCache[slideId]) {
            initialModuleIds[slideId] = moduleIdCache[slideId];
          }
        });

        // Set the moduleIds state
        if (Object.keys(initialModuleIds).length > 0) {
          setModuleIds(initialModuleIds);

          // If we have a moduleId for the first slide, set it as the current moduleId
          const firstSlideId = selectedSlide.slideIds[0];
          if (initialModuleIds[firstSlideId]) {
            setModuleId(initialModuleIds[firstSlideId]);
            setShowModuleAssembly(true);
          }
        }
      }
    }
  }, [selectedSlide]);
  //
  const fullSlideData = modulesData;
  //

  // Update moduleId whenever current module changes
  useEffect(() => {
    const currentSlideId = getCurrentSlideId();
    if (currentSlideId && moduleIds[currentSlideId]) {
      setModuleId(moduleIds[currentSlideId]);
      // console.log(`Setting current moduleId to ${moduleIds[currentSlideId]} for slideId ${currentSlideId}`);

      // Log the current module elements to trace usage type values
      if (moduleElements[currentModule]) {
        // console.log(`Current module ${currentModule} elements:`, moduleElements[currentModule]);
        // Check usage types in current module elements
        if (moduleElements[currentModule].claims) {
          moduleElements[currentModule].claims.forEach((claim) => {
            console.log(`Claim ${claim.claimName} mustUse:`, claim.mustUse);
          });
        }
      }
    } else {
      setModuleId(null);
    }
  }, [currentModule, moduleIds]);

  useEffect(() => {
    if (showModuleElementModal) {
      setIsBack(false);
    }
  }, [showModuleElementModal]);

  const toggleModuleElementModal = () => {
    setShowModuleElementModal(!showModuleElementModal);
    // setIsBack(false);
  };

  const handleBack = () => {
    if (isPreviewOpen) {
      setIsPreviewOpen(false);
    }
    if (currentModule === 1) {
      setIsBack(true);
    }

    // Find previous SELECTED module
    let prevIndex = currentModule - 2; // Start from one before current (0-based)
    while (prevIndex >= 0) {
      if (selectedModules[prevIndex]) {
        setCurrentModule(prevIndex + 1); // Convert to 1-based
        return;
      }
      prevIndex--;
    }

    // If no selected module found before, close modal
    toggleModuleElementModal();
  };

  // Check if module has any elements (claims, reusable texts, components)
  const hasElements = (moduleIndex) => {
    // For multi-module creation, check moduleElements directly
    if (multiModuleCreation) {
      const currentElements = moduleElements[moduleIndex];
      if (!currentElements) return false;

      const hasClaims =
        currentElements.claims && currentElements.claims.length > 0;
      const hasReusableTexts =
        currentElements.reusableTexts &&
        currentElements.reusableTexts.length > 0;
      const hasComponents =
        currentElements.components && currentElements.components.length > 0;

      return hasClaims || hasReusableTexts || hasComponents;
    }

    // For regular flow, check moduleMetadata
    if (!moduleMetadata || !moduleMetadata[moduleIndex - 1]) return false;

    const selectedElements = moduleMetadata[moduleIndex - 1].selectedElements;
    return (
      selectedElements.claims.length > 0 ||
      selectedElements.reusableTexts.length > 0 ||
      selectedElements.components.length > 0
    );
  };

  const findNextSelectedModule = (currentModuleIndex) => {
    if (!selectedModules || selectedModules.length === 0) {
      return null;
    }

    // currentModuleIndex is 1-based
    // Start looking from the module AFTER current (currentModuleIndex is already the next one)
    for (let i = currentModuleIndex; i < selectedModules.length; i++) {
      if (selectedModules[i]) {
        return i + 1; // Return 1-based
      }
    }

    return null;
  };

  const handleNext = async () => {
    // For multi-module creation, we don't rely on slide IDs
    let currentSlideId;

    if (!selectedModules[currentModule - 1]) {
      const nextModule = findNextSelectedModule(currentModule);
      if (nextModule) {
        setCurrentModule(nextModule);
      }
      return; // Always return early for unselected modules
    }

    if (!multiModuleCreation) {
      currentSlideId = getCurrentSlideId();
      if (!currentSlideId) {
        console.error("No slide ID available for the current module");
        return;
      }
    }

    // Check if current module has any elements
    if (!hasElements(currentModule)) {
      // Show message that module is being skipped due to no elements
      toast.info(
        <SuccessfulToastMessage
          message="Module skipped - no claims, reusable texts, or components found"
          otherDetails={{
            Module: `Module ${currentModule}`,
          }}
          handleClose={() => toast.dismiss()}
        />,
        {
          autoClose: 5000,
          position: "top-right",
          closeButton: false,
        },
      );

      setNoElementsWarningShown(true);
      // Move to next SELECTED module (not numeric +1)
      const nextSelectedModule = findNextSelectedModule(currentModule);
      if (nextSelectedModule) {
        setCurrentModule(nextSelectedModule);
      }

      return moduleId; // Return existing moduleId if any
    }

    // Before proceeding, ensure we have the data for the next module
    let response;
    let apiErrorOccurred = false;
    setButtonLoading(true);

    // STORE MUSTUSE MAPS HERE SO THEY CAN BE SAVED LATER
    let claimsMustuseMap = {};
    let reusableTextsMustuseMap = {};
    let componentMustuseMap = {};

    // DECLARE VARIABLES AT FUNCTION SCOPE
    let currentModuleId;
    let moduleKey;

    try {
      // Check if we already have a moduleId for this slide/module
      if (multiModuleCreation) {
        // For multi-module creation, we need to track moduleIds by module index
        moduleKey = `module_${currentModule}`;
        currentModuleId = moduleIds[moduleKey] || null;
      } else {
        currentModuleId = moduleIds[currentSlideId];
        moduleKey = currentSlideId;
      }

      const moduleData = moduleMetadata[currentModule - 1]
        ? moduleMetadata[currentModule - 1]
        : moduleMetadata[currentModule];

      if (!currentModuleId) {
        // CREATE NEW MODULE - existing logic
        try {
          response = await createModulePromise({
            source: "ncci",
            eDetailSourceDocNum: edetailDetails?.eDetailSourceDocNum,
            eDetailDocUrl: edetailDetails?.eDetailDocUrl,
            productDamId: moduleData?.product.veevaId,
            productName: moduleData?.product.displayName,
            countryDamId: moduleData?.country.veevaId,
            countryName: moduleData?.country.displayName,
            topicDamId: moduleData?.topic.veevaId,
            topicName: moduleData?.topic.displayName,
            ...(moduleData?.subTopic?.veevaId && {
              subtopicDamId: moduleData?.subTopic?.veevaId,
              subtopicName: moduleData?.subTopic?.displayName,
            }),
            communicationObjectives: moduleData?.communicationObjectives || "",
            brandStyleGuidelines: moduleData?.brandStyleGuidelines || "",
            createdByName: userName,
            moduleName: moduleData?.name,
            languageDamId: moduleData?.language.veevaId,
            languageName: moduleData?.language.displayName,
            therapeuticAreaDamId: moduleData?.therapeuticArea.veevaId,
            therapeuticAreaName: moduleData?.therapeuticArea.displayName,
            audienceDamId: moduleData?.audience.veevaId,
            audienceName: moduleData?.audience.displayName,
            strategicObjectives: moduleData?.strategicObjective.map((item) => ({
              strategicObjDamId: item.veevaId,
              strategicObjName: item.displayName,
            })),
            segments: moduleData?.segment.map((item) => ({
              segmentDamId: item.veevaId,
              segmentName: item.displayName,
            })),
            indications: moduleData?.indication.map((item) => ({
              indicationDamId: item.veevaId,
              indicationName: item.displayName,
            })),
            draftElementIncluded: moduleData?.draftElementIncluded?.map(
              (item) => ({
                draftElementDamId: item.veevaId,
                draftElementName: item.displayName,
              }),
            ),
            creativeAgencyName: moduleData?.agency.displayName,
            creativeAgencyDamId: moduleData?.agency.veevaId,
            contentToneName: moduleData?.contentTone?.displayName,
            contentToneDamId: moduleData?.contentTone?.veevaId,
          });

          setCreatedModules((prev) => {
            const newCreated = [...prev];
            newCreated[currentModule - 1] = true;
            return newCreated;
          });

          if (response && response.moduleId) {
            // Update moduleIds state with new moduleId
            setModuleIds((prev) => ({
              ...prev,
              [moduleKey]: response.moduleId,
            }));
            setModuleId(response.moduleId);

            // Store original metadata when module is created
            setOriginalModuleMetadata((prev) => ({
              ...prev,
              [response.moduleId]: JSON.parse(JSON.stringify(moduleData)),
            }));
          }
        } catch (err) {
          apiErrorOccurred = true;
          console.error("Error creating module:", err);
          toast.error(
            <UnsuccessfulToastMessage
              message={
                err.response?.data?.message ||
                "Failed to create module. Please try again."
              }
              handleClose={() => toast.dismiss()}
            />,
            {
              autoClose: 5000,
              position: "top-right",
              closeButton: false,
            },
          );
          setButtonLoading(false);
          return;
        }
      } else {
        // UPDATE EXISTING MODULE - NEW LOGIC
        try {
          // Prepare update payload (same as creation payload)
          const updatePayload = {
            source: "ncci",
            eDetailSourceDocNum: edetailDetails?.eDetailSourceDocNum,
            eDetailDocUrl: edetailDetails?.eDetailDocUrl,
            productDamId: moduleData?.product.veevaId,
            productName: moduleData?.product.displayName,
            countryDamId: moduleData?.country.veevaId,
            countryName: moduleData?.country.displayName,
            topicDamId: moduleData?.topic.veevaId,
            topicName: moduleData?.topic.displayName,
            ...(moduleData?.subTopic?.veevaId &&
              moduleData?.subTopic?.displayName && {
                subtopicDamId: moduleData?.subTopic?.veevaId,
                subtopicName: moduleData?.subTopic?.displayName,
              }),
            communicationObjectives: moduleData?.communicationObjectives || "",
            brandStyleGuidelines: moduleData?.brandStyleGuidelines || "",
            createdByName: userName,
            moduleName: moduleData?.name,
            languageDamId: moduleData?.language.veevaId,
            languageName: moduleData?.language.displayName,
            therapeuticAreaDamId: moduleData?.therapeuticArea.veevaId,
            therapeuticAreaName: moduleData?.therapeuticArea.displayName,
            audienceDamId: moduleData?.audience.veevaId,
            audienceName: moduleData?.audience.displayName,
            strategicObjectives: moduleData?.strategicObjective.map((item) => ({
              strategicObjDamId: item.veevaId,
              strategicObjName: item.displayName,
            })),
            segments: moduleData?.segment.map((item) => ({
              segmentDamId: item.veevaId,
              segmentName: item.displayName,
            })),
            indications: moduleData?.indication.map((item) => ({
              indicationDamId: item.veevaId,
              indicationName: item.displayName,
            })),
            draftElementIncluded: moduleData?.draftElementIncluded?.map(
              (item) => ({
                draftElementDamId: item.veevaId,
                draftElementName: item.displayName,
              }),
            ),
            creativeAgencyName: moduleData?.agency.displayName,
            creativeAgencyDamId: moduleData?.agency.veevaId,
            contentToneName: moduleData?.contentTone?.displayName,
            contentToneDamId: moduleData?.contentTone?.veevaId,
          };

          response = await updateModulePromise(updatePayload, currentModuleId);

          if (response) {
            toast.success(
              <SuccessfulToastMessage
                message="Module metadata updated successfully"
                handleClose={() => toast.dismiss()}
              />,
              {
                autoClose: 3000,
                position: "top-right",
                closeButton: false,
              },
            );

            // Update original metadata after successful update
            setOriginalModuleMetadata((prev) => ({
              ...prev,
              [currentModuleId]: JSON.parse(JSON.stringify(moduleData)),
            }));
          }
        } catch (err) {
          apiErrorOccurred = true;
          console.error("Error updating module:", err);
          toast.error(
            <UnsuccessfulToastMessage
              message={
                err.response?.data?.message ||
                "Failed to update module metadata. Please try again."
              }
              handleClose={() => toast.dismiss()}
            />,
            {
              autoClose: 5000,
              position: "top-right",
              closeButton: false,
            },
          );
          setButtonLoading(false);
          return;
        }
      }

      // Add elements to module (existing logic remains the same)
      try {
        // Track which elements are saved to the database
        const savedElements = {
          claims: [],
          reusableTexts: [],
          components: [],
        };

        // Use the existing moduleId or the one from the response
        const activeModuleId = currentModuleId || response?.moduleId;

        if (moduleMetadata[currentModule - 1]?.selectedElements.claims.length) {
          // Build claimsMustuseMap from moduleElements (the correct source)
          claimsMustuseMap = {};
          moduleMetadata[currentModule - 1].selectedElements.claims.forEach(
            (claimId) => {
              const claimIdStr = String(claimId);
              // Find the claim in moduleElements to get the actual mustUse value
              const claimElement = moduleElements[currentModule]?.claims?.find(
                (claim) => claim.claimName === claimIdStr,
              );
              claimsMustuseMap[claimIdStr] = claimElement?.mustUse || false;
            },
          );

          await addElementsToModulePromise("claims", {
            moduleId: activeModuleId,
            claimNames:
              moduleMetadata[currentModule - 1].selectedElements.claims,
            claimsMustuseMap: claimsMustuseMap,
          });
          savedElements.claims = [
            ...moduleMetadata[currentModule - 1].selectedElements.claims,
          ];
        }

        // For reusableTexts
        if (
          moduleMetadata[currentModule - 1].selectedElements.reusableTexts
            .length
        ) {
          reusableTextsMustuseMap = {};
          moduleMetadata[
            currentModule - 1
          ].selectedElements.reusableTexts.forEach((textId) => {
            const textIdStr = String(textId);
            const textElement = moduleElements[
              currentModule
            ]?.reusableTexts?.find(
              (text) => text.reusableTextName === textIdStr,
            );
            reusableTextsMustuseMap[textIdStr] = textElement?.mustUse || false;
          });

          await addElementsToModulePromise("reusableTexts", {
            moduleId: activeModuleId,
            reusableTextNames:
              moduleMetadata[currentModule - 1].selectedElements.reusableTexts,
            reusableTextsMustuseMap: reusableTextsMustuseMap,
          });
          savedElements.reusableTexts = [
            ...moduleMetadata[currentModule - 1].selectedElements.reusableTexts,
          ];
        }

        // For components
        if (
          moduleMetadata[currentModule - 1]?.selectedElements.components.length
        ) {
          componentMustuseMap = {};
          moduleMetadata[currentModule - 1].selectedElements.components.forEach(
            (componentId) => {
              const componentIdStr = String(componentId);
              const componentElement = moduleElements[
                currentModule
              ]?.components?.find(
                (comp) => comp.componentDocNumber === componentIdStr,
              );
              componentMustuseMap[componentIdStr] =
                componentElement?.mustUse || false;
            },
          );

          const componentPromises = moduleMetadata[
            currentModule - 1
          ]?.selectedElements.components.map((componentId) =>
            addElementsToModulePromise("components", {
              moduleId: activeModuleId,
              componentDocNumbers: [componentId],
              componentMustuseMap: {
                [String(componentId)]: componentMustuseMap[String(componentId)],
              },
            }),
          );

          await Promise.all(componentPromises);
          savedElements.components = [
            ...moduleMetadata[currentModule - 1].selectedElements.components,
          ];
        }

        // Update module metadata with saved elements
        setModuleMetadata((prev) => {
          const updatedMetadata = [...prev];
          if (updatedMetadata[currentModule - 1]) {
            updatedMetadata[currentModule - 1] = {
              ...updatedMetadata[currentModule - 1],
              savedElements: {
                ...updatedMetadata[currentModule - 1].savedElements,
                claims: [...savedElements.claims],
                reusableTexts: [...savedElements.reusableTexts],
                components: [...savedElements.components],
              },
              selectedElements: {
                ...updatedMetadata[currentModule - 1].selectedElements,
                claimsMustuseMap: claimsMustuseMap,
                reusableTextsMustuseMap: reusableTextsMustuseMap,
                componentMustuseMap: componentMustuseMap,
              },
            };
          }
          return updatedMetadata;
        });

        // Update module elements with mustUse values
        setModuleElements((prev) => {
          const updatedElements = { ...prev };
          if (updatedElements[currentModule]) {
            // Update claims with mustUse values
            updatedElements[currentModule].claims =
              updatedElements[currentModule].claims?.map((claim) => ({
                ...claim,
                mustUse: claimsMustuseMap[claim.claimName] || false,
              })) || [];

            // Update reusableTexts with mustUse values
            updatedElements[currentModule].reusableTexts =
              updatedElements[currentModule].reusableTexts?.map((text) => ({
                ...text,
                mustUse:
                  reusableTextsMustuseMap[text.reusableTextName] || false,
              })) || [];

            // Update components with mustUse values
            updatedElements[currentModule].components =
              updatedElements[currentModule].components?.map((comp) => ({
                ...comp,
                mustUse: componentMustuseMap[comp.componentDocNumber] || false,
              })) || [];
          }
          return updatedElements;
        });

        // Update cache with new element data
        const currentSlideId = getCurrentSlideId();
        if (currentSlideId && currentSelectedSlide?.assetId) {
          const cacheKey = getCacheKey(
            currentSelectedSlide.assetId,
            currentSlideId,
          );
          if (slideDataCache[cacheKey] && moduleElements[currentModule]) {
            slideDataCache[cacheKey] = {
              ...slideDataCache[cacheKey],
              claims: moduleElements[currentModule]?.claims || [],
              reusableTexts: moduleElements[currentModule]?.reusableTexts || [],
              components: moduleElements[currentModule]?.components || [],
            };
          }
        }

        // Update created modules flag
        setCreatedModules((prev) => {
          const newCreated = [...prev];
          newCreated[currentModule - 1] = true;
          return newCreated;
        });
      } catch (err) {
        apiErrorOccurred = true;
        console.error("Error adding elements to module:", err);
        toast.error(
          <UnsuccessfulToastMessage
            message={
              err.response?.data?.message ||
              "Failed to add elements to module. Please try again."
            }
            handleClose={() => toast.dismiss()}
          />,
          {
            autoClose: 5000,
            position: "top-right",
            closeButton: false,
          },
        );
      }
    } catch (err) {
      apiErrorOccurred = true;
      console.error("Unexpected error in handleNext:", err);
      toast.error(
        <UnsuccessfulToastMessage
          message="An unexpected error occurred. Please try again."
          handleClose={() => toast.dismiss()}
        />,
        {
          autoClose: 5000,
          position: "top-right",
          closeButton: false,
        },
      );
    } finally {
      setButtonLoading(false);
    }

    // MOVE TO NEXT SELECTED MODULE (not numeric +1)
    const nextSelectedModule = findNextSelectedModule(currentModule);
    if (nextSelectedModule) {
      setCurrentModule(nextSelectedModule);
    }

    // Only pre-load next module if NO API error occurred (only for regular flow)
    if (
      !apiErrorOccurred &&
      currentModule < totalModules &&
      !multiModuleCreation &&
      nextSelectedModule
    ) {
      const nextSlideId = selectedSlide?.slideIds[nextSelectedModule - 1];
      if (
        nextSlideId &&
        !processedSlideIds[nextSlideId] &&
        !moduleElements[currentModule + 1]
      ) {
        setProcessedSlideIds((prev) => ({
          ...prev,
          [nextSlideId]: true,
        }));
      }
    }

    // Return the moduleId - FIXED SCOPE ISSUE
    return currentModuleId || response?.moduleId;
  };
  const prepareMustUseMaps = (moduleIndex) => {
    if (!moduleMetadata || !moduleMetadata[moduleIndex - 1]) {
      return {
        claimsMustuseMap: {},
        reusableTextsMustuseMap: {},
        componentMustuseMap: {},
      };
    }

    const moduleData = moduleMetadata[moduleIndex - 1];

    // Prepare claims mustUse map
    const claimsMustuseMap = {};
    if (moduleData.selectedElements.claims.length) {
      // First, initialize all selected claims with default mustUse=false
      moduleData.selectedElements.claims.forEach((claimId) => {
        claimsMustuseMap[String(claimId)] = false;
      });

      // Then override with any explicitly set mustUse values
      if (moduleData.selectedElements.claimsMustuseMap) {
        Object.keys(moduleData.selectedElements.claimsMustuseMap).forEach(
          (key) => {
            if (moduleData.selectedElements.claims.includes(key)) {
              claimsMustuseMap[String(key)] =
                moduleData.selectedElements.claimsMustuseMap[key];
            }
          },
        );
      }
    }

    // Prepare reusable texts mustUse map
    const reusableTextsMustuseMap = {};
    if (moduleData.selectedElements.reusableTexts.length) {
      // First, initialize all selected reusable texts with default mustUse=false
      moduleData.selectedElements.reusableTexts.forEach((textId) => {
        reusableTextsMustuseMap[String(textId)] = false;
      });

      // Then override with any explicitly set mustUse values
      if (moduleData.selectedElements.reusableTextsMustuseMap) {
        Object.keys(
          moduleData.selectedElements.reusableTextsMustuseMap,
        ).forEach((key) => {
          if (moduleData.selectedElements.reusableTexts.includes(key)) {
            reusableTextsMustuseMap[String(key)] =
              moduleData.selectedElements.reusableTextsMustuseMap[key];
          }
        });
      }
    }

    // Prepare components mustUse map
    const componentMustuseMap = {};
    if (moduleData.selectedElements.components.length) {
      // First, initialize all selected components with default mustUse=false
      moduleData.selectedElements.components.forEach((componentId) => {
        componentMustuseMap[String(componentId)] = false;
      });

      // Then override with any explicitly set mustUse values
      if (moduleData.selectedElements.componentMustuseMap) {
        Object.keys(moduleData.selectedElements.componentMustuseMap).forEach(
          (key) => {
            if (moduleData.selectedElements.components.includes(key)) {
              componentMustuseMap[String(key)] =
                moduleData.selectedElements.componentMustuseMap[key];
            }
          },
        );
      }
    }

    return {
      claimsMustuseMap,
      reusableTextsMustuseMap,
      componentMustuseMap,
    };
  };

  const handleMetadataChange = (
    moduleIndex,
    field,
    value,
    originalValue,
    elementIds,
  ) => {
    if (!moduleMetadata?.length) {
      console.error("moduleMetadata is empty or undefined");
      return;
    }

    // Special handling for selectedElements - keep them module-specific
    if (field === "selectedElements") {
      setModuleMetadata((prev) => {
        const updatedMetadata = [...prev];
        // Only update the selectedElements for the specific module
        if (updatedMetadata[moduleIndex - 1]) {
          updatedMetadata[moduleIndex - 1] = {
            ...updatedMetadata[moduleIndex - 1],
            [field]: { ...updatedMetadata[moduleIndex - 1][field], ...value },
          };
        }
        return updatedMetadata;
      });
      return;
    }

    // For all other metadata fields, apply the change only to the specific module
    setModuleMetadata((prev) => {
      const updatedMetadata = [...prev];
      const moduleIndexToUpdate = moduleIndex - 1; // Convert to 0-based index
      // Ensure the module exists
      if (!updatedMetadata[moduleIndexToUpdate]) {
        console.error(
          `Module index ${moduleIndexToUpdate} doesn't exist in metadata`,
        );
        return prev;
      }
      // Update the specific field for the specific module
      updatedMetadata[moduleIndexToUpdate] = {
        ...updatedMetadata[moduleIndexToUpdate],
        [field]: value,
      };

      return updatedMetadata;
    });
  };

  const handleGenerateCMSD = async () => {
    // Get ALL invalid modules
    const invalidModules = [];

    selectedModules.forEach((isSelected, index) => {
      if (isSelected) {
        const moduleIndex = index + 1; // 1-based

        // Skip modules with no elements
        if (!hasElements(moduleIndex)) {
          return;
        }

        // Check if this module has valid metadata
        const moduleMeta = moduleMetadata[index];
        const moduleElems = moduleElements[moduleIndex];

        if (!moduleMeta) {
          // Module metadata doesn't exist yet
          const moduleName = getModuleDisplayName(index);
          invalidModules.push(moduleName);
          return;
        }

        // Replicate child's validation logic
        const hasAvailableClaims =
          moduleElems?.claims && moduleElems.claims.length > 0;
        const hasAvailableRTs =
          moduleElems?.reusableTexts && moduleElems.reusableTexts.length > 0;

        const hasSelectedClaims =
          moduleMeta?.selectedElements?.claims?.length > 0;
        const hasSelectedRTs =
          moduleMeta?.selectedElements?.reusableTexts?.length > 0;

        // Require at least ONE claim OR ONE reusable text when available
        const hasValidElementSelection =
          (!hasAvailableClaims && !hasAvailableRTs) || // If no elements available
          hasSelectedClaims ||
          hasSelectedRTs;

        const validation = {
          name: !!moduleMeta?.name?.trim(),
          product: !!moduleMeta?.product?.veevaId,
          country: !!moduleMeta?.country?.veevaId,
          topic: !!moduleMeta?.topic?.veevaId,
          // subTopic: !!moduleMeta?.subTopic?.veevaId,
          language: !!moduleMeta?.language?.veevaId,
          audience: !!moduleMeta?.audience?.veevaId,
          therapeuticArea: !!moduleMeta?.therapeuticArea?.veevaId,
          communicationObjectives:
            !!moduleMeta?.communicationObjectives?.trim(),
          segment: Array.isArray(moduleMeta?.segment)
            ? moduleMeta.segment.length > 0
            : !!moduleMeta?.segment,
          draftElementsValid:
            moduleMeta?.country?.veevaId !== "unitedStates" ||
            (Array.isArray(moduleMeta?.draftElementIncluded)
              ? moduleMeta.draftElementIncluded.length > 0
              : !!moduleMeta?.draftElementIncluded?.veevaId),
          agency: !!moduleMeta?.agency?.veevaId,
          elementsSelected: hasValidElementSelection,
        };

        const isValid = Object.values(validation).every(
          (value) => value === true,
        );

        if (!isValid) {
          // Get module display name
          let moduleName;
          if (multiModuleCreation && multipleModulesData[index]) {
            moduleName =
              multipleModulesData[index].moduleNumber ||
              `Module_${moduleIndex}`;
          } else {
            moduleName = `Module_${moduleIndex}`;
          }
          invalidModules.push(moduleName);
        }
      }
    });

    // If any modules are invalid, show popup
    if (invalidModules.length > 0) {
      setMissingMetadataModules(invalidModules);
      setShowMissingMetadataPopup(true);
      return; // Stop here, don't proceed
    }

    // All modules are valid, proceed
    await handleNext();
    confirmPublish();
    setModalCompleted((prev) => ({ ...prev, moduleAssembly: true }));
  };

  // Helper function to get module display name
  const getModuleDisplayName = (index) => {
    if (multiModuleCreation && multipleModulesData[index]) {
      return multipleModulesData[index].moduleNumber || `Module_${index + 1}`;
    } else {
      return `Module_${index + 1}`;
    }
  };

  // Function to check ALL selected modules
  const checkAllSelectedModules = () => {
    const invalidModules = [];

    selectedModules.forEach((isSelected, index) => {
      if (isSelected) {
        const moduleIndex = index + 1; // 1-based

        // Check if this module has elements
        const hasModuleElements = hasElements(moduleIndex);

        // Skip modules with no elements (they'll be skipped anyway)
        if (!hasModuleElements) {
          return;
        }

        // Check if this module would pass the child's validation
        const moduleMeta = moduleMetadata[index];
        const moduleElems = moduleElements[moduleIndex];

        // Replicate child's validation logic
        const hasAvailableClaims =
          moduleElems?.claims && moduleElems.claims.length > 0;
        const hasAvailableRTs =
          moduleElems?.reusableTexts && moduleElems.reusableTexts.length > 0;

        const hasSelectedClaims =
          moduleMeta?.selectedElements?.claims?.length > 0;
        const hasSelectedRTs =
          moduleMeta?.selectedElements?.reusableTexts?.length > 0;

        // Require at least ONE claim OR ONE reusable text when available
        const hasValidElementSelection =
          (!hasAvailableClaims && !hasAvailableRTs) || // If no elements available
          hasSelectedClaims ||
          hasSelectedRTs;

        const validation = {
          name: !!moduleMeta?.name?.trim(),
          product: !!moduleMeta?.product?.veevaId,
          country: !!moduleMeta?.country?.veevaId,
          topic: !!moduleMeta?.topic?.veevaId,
          // subTopic: !!moduleMeta?.subTopic?.veevaId,
          language: !!moduleMeta?.language?.veevaId,
          audience: !!moduleMeta?.audience?.veevaId,
          therapeuticArea: !!moduleMeta?.therapeuticArea?.veevaId,
          communicationObjectives:
            !!moduleMeta?.communicationObjectives?.trim(),
          segment: Array.isArray(moduleMeta?.segment)
            ? moduleMeta.segment.length > 0
            : !!moduleMeta?.segment,
          draftElementsValid:
            moduleMeta?.country?.veevaId !== "unitedStates" ||
            (Array.isArray(moduleMeta?.draftElementIncluded)
              ? moduleMeta.draftElementIncluded.length > 0
              : !!moduleMeta?.draftElementIncluded?.veevaId),
          agency: !!moduleMeta?.agency?.veevaId,
          elementsSelected: hasValidElementSelection,
        };

        const isValid = Object.values(validation).every(
          (value) => value === true,
        );

        if (!isValid) {
          // Get module display name
          let moduleName;
          if (multiModuleCreation && multipleModulesData[index]) {
            moduleName =
              multipleModulesData[index].moduleNumber ||
              `Module_${moduleIndex}`;
          } else {
            moduleName = `Module_${moduleIndex}`;
          }
          invalidModules.push(moduleName);
        }
      }
    });

    return invalidModules;
  };
  const confirmPublish = async () => {
    // Close module element modal after publishing
    toggleModuleElementModal();

    // Show CMSD flow message
    setShowCMSDFlow(true);
  };

  const handleCloseAnalyseModal = () => {
    setShowAnalyseModal(false);
    // Show module assembly status after analyze modal is closed
  };

  const [elementsLoading, setElementsLoading] = useState(false);
  const [elementsError, setElementsError] = useState(null);

  // Helper function to get cache key
  const getCacheKey = (assetId, slideId) => `${assetId}-${slideId}`;

  // Fetch elements for a specific module and slideId
  const fetchModuleElements = async (moduleIndex, slideId) => {
    // GUARD 1: Check if we're already processing this slideId
    if (processedSlideIds[slideId] === true) {
      return;
    }

    // GUARD 2: Check if we already have data for this module
    if (
      moduleElements[moduleIndex] &&
      Object.keys(moduleElements[moduleIndex]).length > 0
    ) {
      return;
    }

    // GUARD 3: Check cache first
    if (!currentSelectedSlide?.assetId || !slideId) return;

    if (
      moduleElements[moduleIndex] &&
      Object.keys(moduleElements[moduleIndex]).length > 0 &&
      selectedModules[moduleIndex - 1] && // Module is selected
      createdModules[moduleIndex - 1] // Module is created
    ) {
      return;
    }
    if (multiModuleCreation && multipleModulesData.length > 0) {
      // Find the module that corresponds to the current module index
      const moduleData = multipleModulesData[moduleIndex - 1];

      if (moduleData) {
        const transformedData = transformApiDataToModuleFormat(moduleData);

        setModuleElements((prev) => ({
          ...prev,
          [moduleIndex]: transformedData,
        }));

        // Update module metadata from the transformed data - THIS IS THE KEY FIX
        updateModuleMetadataFromApiResponse(moduleIndex, transformedData);

        // Mark as processed
        setProcessedSlideIds((prev) => ({
          ...prev,
          [slideId]: true,
        }));

        return;
      } else {
        console.log(
          `No module data found for module ${moduleIndex} in multipleModulesData`,
        );
      }
    }

    if (!currentSelectedSlide?.assetId || !slideId) return;

    const cacheKey = getCacheKey(currentSelectedSlide.assetId, slideId);

    // Check if we already have data in the global cache
    if (slideDataCache[cacheKey]) {
      // console.log(`RetrivedSlide: Using GLOBAL cached data for module ${moduleIndex}, slideId ${slideId}`);
      setModuleElements((prev) => ({
        ...prev,
        [moduleIndex]: slideDataCache[cacheKey],
      }));

      // Also update the module metadata from the cached data
      updateModuleMetadataFromApiResponse(
        moduleIndex,
        slideDataCache[cacheKey],
      );

      // If the API response includes a moduleId, store it in our moduleIds state and cache
      if (slideDataCache[cacheKey]?.moduleId) {
        const moduleIdFromCache = slideDataCache[cacheKey].moduleId;

        // Update moduleIds state
        setModuleIds((prev) => ({
          ...prev,
          [slideId]: moduleIdFromCache,
        }));

        // Update global cache
        moduleIdCache[slideId] = moduleIdFromCache;
        // console.log(`Retrieved moduleId ${moduleIdFromCache} from cached data for slideId ${slideId}`);

        // If this is the current module, update the current moduleId
        if (moduleIndex === currentModule) {
          setModuleId(moduleIdFromCache);
        }
      }

      return;
    }

    // Check if we already have data for this module in component state
    if (
      moduleElements[moduleIndex] &&
      Object.keys(moduleElements[moduleIndex]).length > 0
    ) {
      return;
    }

    // Check if we already processed this slideId
    if (processedSlideIds[slideId]) {
      return;
    }

    // console.log(`RetrivedSlide: Fetching data for module ${moduleIndex}, slideId ${slideId}`);
    setElementsLoading(true);
    setElementsError(null);

    try {
      // Make API call for the module with corresponding slideId

      const moduleData = await classifySlideAssets(
        currentSelectedSlide.assetId,
        slideId,
        countryNameUI,
        userCollectedMeta[userCollectedMeta.length - 1].objective,
        userCollectedMeta[userCollectedMeta.length - 1].topic,
      );

      // Store in global cache
      slideDataCache[cacheKey] = moduleData;

      // Skip items with error but mark as processed
      if (moduleData.error === "No items to classify") {
        setModuleElements((prev) => ({
          ...prev,
          [moduleIndex]: {},
        }));
      } else {
        const existingElements = moduleElements[moduleIndex] || {};
        setModuleElements((prev) => ({
          ...prev,
          [moduleIndex]: {
            ...moduleData,
            claims:
              moduleData.claims?.map((claim) => {
                // Find existing claim to preserve mustUse value
                const existingClaim = existingElements.claims?.find(
                  (c) => c.claimName === claim.claimName,
                );
                return {
                  ...claim,
                  mustUse: existingClaim?.mustUse || false,
                };
              }) || [],
            components:
              moduleData.components?.map((component) => {
                const existingComponent = existingElements.components?.find(
                  (c) => c.componentDocNumber === component.componentDocNumber,
                );
                return {
                  ...component,
                  mustUse: existingComponent?.mustUse || false,
                };
              }) || [],
            reusableTexts:
              moduleData.reusableTexts?.map((text) => {
                const existingText = existingElements.reusableTexts?.find(
                  (t) => t.reusableTextName === text.reusableTextName,
                );
                return {
                  ...text,
                  mustUse: existingText?.mustUse || false,
                };
              }) || [],
          },
        }));

        // Store the result in moduleElements with the module index as key
        // setModuleElements((prev) => ({
        //   ...prev,
        //   [moduleIndex]: {
        //     ...moduleData,
        //     claims:
        //       moduleData.claims?.map((claim) => ({
        //         ...claim,
        //         mustUse: false,
        //       })) || [],
        //     components:
        //       moduleData.components?.map((component) => ({
        //         ...component,
        //         mustUse: false,
        //       })) || [],
        //     reusableTexts:
        //       moduleData.reusableTexts?.map((text) => ({
        //         ...text,
        //         mustUse: false,
        //       })) || [],
        //   },
        // }));

        // If the API response includes a moduleId, store it in our moduleIds state and cache
        if (moduleData.moduleId) {
          // Update moduleIds state
          setModuleIds((prev) => ({
            ...prev,
            [slideId]: moduleData.moduleId,
          }));

          // Update global cache
          moduleIdCache[slideId] = moduleData.moduleId;
          // console.log(`Retrieved moduleId ${moduleData.moduleId} from API response for slideId ${slideId}`);

          // If this is the current module, update the current moduleId
          if (moduleIndex === currentModule) {
            setModuleId(moduleData.moduleId);
          }
        }

        // Prepare savedElements from API response
        const savedElements = {
          claims: moduleData?.claims?.map((claim) => claim?.claimName) || [],
          reusableTexts:
            moduleData?.reusableTexts?.map((text) => text?.reusableTextName) ||
            [],
          components:
            moduleData?.components?.map((comp) => comp?.componentDocNumber) ||
            [],
        };

        // Immediately update moduleMetadata with savedElements
        setModuleMetadata((prev) => {
          const updatedMetadata = [...prev];
          if (updatedMetadata[moduleIndex - 1]) {
            updatedMetadata[moduleIndex - 1] = {
              ...updatedMetadata[moduleIndex - 1],
              savedElements: savedElements,
            };
          }
          return updatedMetadata;
        });

        // Update module metadata from API response
        updateModuleMetadataFromApiResponse(moduleIndex, moduleData);
      }

      // Mark this slideId as processed
      setProcessedSlideIds((prev) => ({
        ...prev,
        [slideId]: true,
      }));
    } catch (err) {
      console.error(`Error fetching data for module ${moduleIndex}:`, err);
      setElementsError(
        err.message || `Failed to fetch elements for module ${moduleIndex}.`,
      );
    } finally {
      setElementsLoading(false);
    }
  };

  const getObject = (data, key) => {
    let obj = {};

    //eslint-disable-next-line
    data?.forEach((item) => {
      if (item?.[key]) {
        obj[item[key]] = item.mustUse || false;
      }
    });

    // console.log("getObject", obj);

    return obj;
  };

  // Helper function to update module metadata from API response
  const updateModuleMetadataFromApiResponse = (moduleIndex, apiData) => {
    if (!apiData || moduleIndex < 1) return;

    const isSpainBiktarvy =
      apiData?.countryName === "Spain" && apiData?.productName === "Biktarvy";

    setModuleMetadata((prev) => {
      if (!prev || prev.length === 0) return prev;

      // First, update the specific module
      const updatedMetadata = [...prev];
      const currentModuleIndex = moduleIndex - 1;

      const existingMetadata = updatedMetadata[currentModuleIndex];
      if (!existingMetadata) return prev;

      // Create a copy of the existing metadata to preserve user modifications
      const moduleMetadata = { ...existingMetadata };

      // Check if user has already modified these fields
      // Check existingMetadata.name
      const hasUserModifiedName =
        existingMetadata.name &&
        existingMetadata.name !== "" &&
        existingMetadata.name !== `Module ${moduleIndex}`;
      const hasUserModifiedLanguage =
        existingMetadata.language &&
        existingMetadata.language.displayName !== "";
      const hasUserModifiedAudience =
        existingMetadata.audience &&
        existingMetadata.audience.displayName !== "";
      const hasUserModifiedCommunicationObjectives =
        existingMetadata.communicationObjectives &&
        existingMetadata.communicationObjectives !== "";
      const hasUserModifiedIndication =
        existingMetadata.indication && existingMetadata.indication.length > 0;

      // Check if we have existing selectedElements to preserve user selections
      const existingSelectedElements = moduleMetadata.selectedElements;
      const hasExistingSelections =
        existingSelectedElements &&
        (existingSelectedElements.claims.length > 0 ||
          existingSelectedElements.reusableTexts.length > 0 ||
          existingSelectedElements.components.length > 0);

      // Use existing selections if they exist, otherwise initialize from API
      const selectedElements = hasExistingSelections
        ? // PRESERVE EXISTING USER SELECTIONS
          {
            claims: [...existingSelectedElements.claims],
            reusableTexts: [...existingSelectedElements.reusableTexts],
            components: [...existingSelectedElements.components],
            claimsMustuseMap: { ...existingSelectedElements.claimsMustuseMap },
            reusableTextsMustuseMap: {
              ...existingSelectedElements.reusableTextsMustuseMap,
            },
            componentMustuseMap: {
              ...existingSelectedElements.componentMustuseMap,
            },
          }
        : // INITIALIZE FROM API selectedElements
          {
            claims:
              apiData?.claims
                ?.map((claim) => claim?.claimName)
                .filter(Boolean) || [],
            reusableTexts:
              apiData?.reusableTexts
                ?.map((text) => text?.reusableTextName)
                .filter(Boolean) || [],
            components:
              apiData?.components
                ?.map((comp) => comp?.componentDocNumber)
                .filter(Boolean) || [],
            claimsMustuseMap: {},
            reusableTextsMustuseMap: {},
            componentMustuseMap: {},
          };

      // ALWAYS initialize mustuse maps from API data, but preserve existing values
      if (apiData?.claims && Array.isArray(apiData.claims)) {
        apiData.claims.forEach((claim) => {
          if (claim.claimName) {
            // Only set if not already exists (preserve user changes)
            if (!(claim.claimName in selectedElements.claimsMustuseMap)) {
              selectedElements.claimsMustuseMap[String(claim.claimName)] =
                false;
            }
          }
        });
      }

      if (apiData?.reusableTexts && Array.isArray(apiData.reusableTexts)) {
        apiData.reusableTexts.forEach((text) => {
          if (text.reusableTextName) {
            // Only set if not already exists (preserve user changes)
            if (
              !(
                text.reusableTextName in
                selectedElements.reusableTextsMustuseMap
              )
            ) {
              selectedElements.reusableTextsMustuseMap[
                String(text.reusableTextName)
              ] = false;
            }
          }
        });
      }

      if (apiData?.components && Array.isArray(apiData.components)) {
        apiData.components.forEach((comp) => {
          if (comp.componentDocNumber) {
            // Only set if not already exists (preserve user changes)
            if (
              !(comp.componentDocNumber in selectedElements.componentMustuseMap)
            ) {
              selectedElements.componentMustuseMap[
                String(comp.componentDocNumber)
              ] = false;
            }
          }
        });
      }

      // Initialize savedElements - preserve existing or use current selections
      const savedElements = moduleMetadata.savedElements || {
        claims: [...selectedElements.claims],
        reusableTexts: [...selectedElements.reusableTexts],
        components: [...selectedElements.components],
      };

      // Initialize mustuse maps from API data

      if (apiData?.claims && Array.isArray(apiData.claims)) {
        apiData.claims.forEach((claim) => {
          if (claim.claimName) {
            selectedElements.claimsMustuseMap[String(claim.claimName)] =
              claim.mustUse || false;
          }
        });
      }

      if (apiData?.reusableTexts && Array.isArray(apiData.reusableTexts)) {
        apiData.reusableTexts.forEach((text) => {
          if (text.reusableTextName) {
            selectedElements.reusableTextsMustuseMap[
              String(text.reusableTextName)
            ] = text.mustUse || false;
          }
        });
      }

      if (apiData?.components && Array.isArray(apiData.components)) {
        apiData.components.forEach((comp) => {
          if (comp.componentDocNumber) {
            selectedElements.componentMustuseMap[
              String(comp.componentDocNumber)
            ] = comp.mustUse || false;
          }
        });
      }

      // Module-specific metadata from API data - ONLY UPDATE IF NOT ALREADY SET BY USER
      const moduleSpecificMetadata = {};

      // Update country if available AND not already set
      if (
        apiData?.countryName &&
        apiData?.countryDamId &&
        !moduleMetadata.country?.displayName
      ) {
        moduleSpecificMetadata.country = {
          id: apiData?.countryDamId || "",
          displayName: apiData?.countryName,
          veevaId: apiData?.countryDamId,
          isSelectable: true,
        };
      }

      // Update product if available AND not already set
      if (
        apiData?.productName &&
        apiData?.productDamId &&
        !moduleMetadata.product?.displayName
      ) {
        moduleSpecificMetadata.product = {
          id: apiData?.productDamId || "",
          displayName: apiData?.productName,
          veevaId: apiData?.productDamId,
          isSelectable: true,
        };
      }

      // Update other metadata fields if they exist in the API response AND not already set by user
      if (
        apiData?.topicName &&
        apiData?.topicDamId &&
        !moduleMetadata.topic?.displayName
      ) {
        moduleSpecificMetadata.topic = {
          id: apiData?.topicDamId || "",
          displayName: apiData?.topicName,
          veevaId: apiData?.topicDamId,
          isSelectable: true,
        };
      }

      if (
        apiData?.subtopicName &&
        apiData?.subtopicDamId &&
        !moduleMetadata.subTopic?.displayName
      ) {
        moduleSpecificMetadata.subTopic = {
          id: apiData?.subtopicDamId || "",
          displayName: apiData?.subtopicName,
          veevaId: apiData?.subtopicDamId,
          isSelectable: true,
        };
      }

      // LANGUAGE: Only update if user hasn't modified it
      if (
        apiData?.languageName &&
        apiData?.languageDamId &&
        !hasUserModifiedLanguage
      ) {
        // Check if we need to override for Spain+Biktarvy
        let finalLanguageName = apiData.languageName;
        let finalLanguageDamId = apiData.languageDamId;

        if (isSpainBiktarvy) {
          finalLanguageName = "Spanish";
          finalLanguageDamId = "V5B000000001026";
        }

        moduleSpecificMetadata.language = {
          id: finalLanguageDamId,
          displayName: finalLanguageName,
          veevaId: finalLanguageDamId,
          metaDataType: apiData?.language?.metaDataType || "",
          isSelectable: true,
        };
      }

      // Therapeutic Area: Only update if user hasn't modified it
      if (
        apiData?.therapeuticAreaName &&
        apiData?.therapeuticAreaDamId &&
        !moduleMetadata.therapeuticArea?.displayName
      ) {
        let finalTherapeuticAreaName = apiData.therapeuticAreaName;
        let finalTherapeuticAreaDamId = apiData.therapeuticAreaDamId;

        if (isSpainBiktarvy) {
          finalTherapeuticAreaName = "HIV";
          finalTherapeuticAreaDamId = "V1L000000001007";
        }

        moduleSpecificMetadata.therapeuticArea = {
          id: finalTherapeuticAreaDamId,
          displayName: finalTherapeuticAreaName,
          veevaId: finalTherapeuticAreaDamId,
          isSelectable: true,
        };
      }

      // AUDIENCE: Only update if user hasn't modified it
      if (
        apiData?.audienceName &&
        apiData?.audienceDamId &&
        !hasUserModifiedAudience
      ) {
        let finalAudienceName = apiData.audienceName;
        let finalAudienceDamId = apiData.audienceDamId;

        if (isSpainBiktarvy) {
          finalAudienceName = "Professional";
          finalAudienceDamId = "V3T000000001003";
        }

        moduleSpecificMetadata.audience = {
          id: finalAudienceDamId,
          displayName: finalAudienceName,
          veevaId: finalAudienceDamId,
          isSelectable: true,
        };
      } else if (
        (!hasUserModifiedAudience && isSpainBiktarvy) ||
        apiData?.audienceName === "Professional"
      ) {
        // Only apply Spain+Biktarvy override if audience hasn't been set by user
        moduleSpecificMetadata.audience = {
          id: "V3T000000001003",
          displayName: "Professional",
          veevaId: "V3T000000001003",
          isSelectable: true,
        };
      }

      if (
        apiData?.creativeAgencyName &&
        apiData?.creativeAgencyDamId &&
        !moduleMetadata.agency?.displayName
      ) {
        moduleSpecificMetadata.agency = {
          id: apiData?.agency?.id || null,
          displayName: apiData?.creativeAgencyName,
          veevaId: apiData?.creativeAgencyDamId,
          metaDataType: apiData?.agency?.metaDataType || "",
          isSelectable: true,
        };
      }

      if (
        apiData?.contentToneName &&
        apiData?.contentToneDamId &&
        !moduleMetadata.contentTone?.displayName
      ) {
        moduleSpecificMetadata.contentTone = {
          id: apiData?.contentTone?.id || null,
          displayName: apiData?.contentToneName,
          veevaId: apiData?.contentToneDamId,
          metaDataType: apiData?.contentTone?.metaDataType || "",
          isSelectable: true,
        };
      }

      // Communication Objectives: Only update if user hasn't modified it
      if (
        apiData?.communicationObjectives &&
        !hasUserModifiedCommunicationObjectives
      ) {
        moduleSpecificMetadata.communicationObjectives =
          apiData?.communicationObjectives;
      }

      if (
        apiData?.brandStyleGuidelines &&
        !moduleMetadata.brandStyleGuidelines
      ) {
        moduleSpecificMetadata.brandStyleGuidelines =
          apiData?.brandStyleGuidelines;
      }

      // Update strategic objectives if available AND not already set
      if (
        apiData?.strategicObjectives &&
        Array.isArray(apiData?.strategicObjectives) &&
        (!moduleMetadata.strategicObjective ||
          moduleMetadata.strategicObjective.length === 0)
      ) {
        moduleSpecificMetadata.strategicObjective =
          apiData?.strategicObjectives?.map((obj) => ({
            id: obj?.id || null,
            displayName: obj?.strategicObjName || "",
            veevaId: obj?.strategicObjDamId || "",
            metaDataType: obj?.metaDataType || "",
            isSelectable: true,
          }));
      }

      // Update segments if available AND not already set
      if (
        apiData?.segments &&
        Array.isArray(apiData?.segments) &&
        (!moduleMetadata.segment || moduleMetadata.segment.length === 0)
      ) {
        moduleSpecificMetadata.segment = apiData?.segments?.map((seg) => ({
          id: seg?.id || 1,
          displayName: seg?.segmentName || "",
          veevaId: seg?.segmentDamId || "",
          metaDataType: seg?.metaDataType || "",
          isSelectable: true,
        }));
      }

      // INDICATIONS: Only update if user hasn't modified it
      if (
        apiData?.indications &&
        Array.isArray(apiData?.indications) &&
        !hasUserModifiedIndication
      ) {
        // Process existing API indications first
        const existingIndications = apiData.indications.map((ind) => ({
          id: ind?.indicationDamId || ind?.id || "",
          displayName: ind?.indicationName || "",
          veevaId: ind?.indicationDamId || "",
          metaDataType: ind?.metaDataType || "",
          isSelectable: true,
        }));

        if (isSpainBiktarvy) {
          // Add HIV Treatment if not already present
          const hivTreatmentDefault = {
            id: "hiv_treatment__c",
            displayName: "HIV Treatment",
            veevaId: "hiv_treatment__c",
            metaDataType: "Indication",
            isSelectable: true,
          };

          const hasHivTreatment = existingIndications.some(
            (ind) => ind.id === "hiv_treatment__c",
          );

          moduleSpecificMetadata.indication = hasHivTreatment
            ? existingIndications
            : [hivTreatmentDefault, ...existingIndications];
        } else {
          moduleSpecificMetadata.indication = existingIndications;
        }
      }

      if (
        apiData?.country?.veevaId === "unitedStates" &&
        apiData?.draftElementIncluded &&
        Array.isArray(apiData?.draftElementIncluded) &&
        (!moduleMetadata.draftElementIncluded ||
          moduleMetadata.draftElementIncluded.length === 0)
      ) {
        moduleSpecificMetadata.draftElementIncluded =
          apiData?.draftElementIncluded?.map((item) => ({
            id: item?.id || "",
            displayName: item?.draftElementName || "",
            veevaId: item?.draftElementDamId || "",
            metaDataType: item?.metaDataType || "",
            isSelectable: true,
          }));
      }

      // MODULE NAME: Only update from API if user hasn't modified it AND it's not the default "Module X"
      // Check if apiData has moduleName and user hasn't modified it
      if (apiData?.moduleName && !hasUserModifiedName) {
        moduleSpecificMetadata.name = apiData?.moduleName;
      }

      // Set edetailDetails if at least eDetailDocUrl exists (this is less critical for user modifications)
      if (apiData?.eDetailDocUrl) {
        setEdetailDetails({
          eDetailDocUrl: apiData.eDetailDocUrl,
          eDetailSourceDocNum: apiData?.eDetailSourceDocNum || "",
        });
      }

      // Update only the current module with its specific metadata
      updatedMetadata[currentModuleIndex] = {
        ...updatedMetadata[currentModuleIndex],
        ...moduleSpecificMetadata,
        selectedElements,
        // Only set savedElements if it doesn't already exist or if we want to update it
        savedElements:
          updatedMetadata[currentModuleIndex].savedElements || savedElements,
      };

      return updatedMetadata;
    });
  };
  useEffect(() => {
    if (
      showModuleElementModal &&
      currentSelectedSlide?.assetId &&
      currentSelectedSlide?.slideIds?.length
    ) {
      initializeModules();
    }
  }, [
    showModuleElementModal,
    currentSelectedSlide?.assetId,
    currentSelectedSlide?.slideIds,
  ]);

  // When current module changes, ensure we have data for that module
  useEffect(() => {
    if (
      showModuleElementModal &&
      currentSelectedSlide?.slideIds &&
      currentModule > 0 &&
      currentModule <= currentSelectedSlide.slideIds.length
    ) {
      const slideId = currentSelectedSlide.slideIds[currentModule - 1];
      // Only fetch if we haven't processed this slide ID yet AND it's not being loaded in handleNext
      // if (slideId && !processedSlideIds[slideId]) {
      if (slideId && !processedSlideIds[slideId]) {
        fetchModuleElements(currentModule, slideId);
      }
    }
  }, [currentModule, showModuleElementModal, processedSlideIds]);

  const initializeModules = async () => {
    if (isBack) {
      return;
    }

    if (!currentSelectedSlide) return;

    let numModules;
    let newModuleMetadata = [];

    // Determine number of modules
    if (multiModuleCreation && multipleModulesData.length > 0) {
      numModules = multipleModulesData.length;
    } else {
      if (
        !currentSelectedSlide.slideIds ||
        !Array.isArray(currentSelectedSlide.slideIds) ||
        currentSelectedSlide.slideIds.length === 0
      ) {
        return;
      }
      numModules = currentSelectedSlide.slideIds.length;
    }

    // Initialize selectedModules (all true by default) and createdModules (all false)
    // BUT preserve existing states if they exist (for when modal re-opens)
    const initialSelectedModules =
      selectedModules.length === numModules
        ? selectedModules
        : Array(numModules).fill(true);

    const initialCreatedModules =
      createdModules.length === numModules
        ? createdModules
        : Array(numModules).fill(false);

    setSelectedModules(initialSelectedModules);
    setCreatedModules(initialCreatedModules);

    // Initialize moduleMetadata with the correct number of modules
    const baseModule = {
      country: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      product: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      indication: [],
      language: {
        id: "",
        displayName: "",
        veevaId: "",
        metaDataType: "",
        isSelectable: true,
      },
      topic: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      subTopic: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      audience: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      therapeuticArea: {
        id: "",
        displayName: "",
        veevaId: "",
        isSelectable: true,
      },
      segment: [],
      strategicObjective: [],
      brandStyleGuidelines: "",
      communicationObjectives: "",
      agency: {
        id: null,
        displayName: "",
        veevaId: "",
        metaDataType: "",
        isSelectable: true,
      },
      contentTone: {
        id: null,
        displayName: "",
        veevaId: "",
        metaDataType: "",
        isSelectable: true,
      },
    };

    for (let i = 0; i < numModules; i++) {
      newModuleMetadata.push({
        ...baseModule,
        id: i + 1,
        name: multiModuleCreation ? `Module ${i + 1}` : "",
        selectedElements: {
          claims: [],
          reusableTexts: [],
          components: [],
          claimsMustuseMap: {},
          reusableTextsMustuseMap: {},
          componentMustuseMap: {},
        },
        savedElements: {
          claims: [],
          reusableTexts: [],
          components: [],
        },
      });
    }

    // Set the total modules and metadata
    setTotalModules(numModules);
    setModuleMetadata(newModuleMetadata);

    // Now handle flow-specific logic
    if (multiModuleCreation && multipleModulesData.length > 0) {
      // Pre-populate all modules with data from multipleModulesData
      multipleModulesData.forEach((moduleData, index) => {
        const moduleIndex = index + 1;
        const transformedData = transformApiDataToModuleFormat(moduleData);

        // Update module elements
        setModuleElements((prev) => ({
          ...prev,
          [moduleIndex]: transformedData,
        }));

        // Update module metadata - but only if not already set
        if (
          !moduleMetadata[moduleIndex - 1]?.selectedElements?.claims?.length
        ) {
          updateModuleMetadataFromApiResponse(moduleIndex, transformedData);
        }
      });

      // Mark all slides as processed to prevent individual API calls
      if (currentSelectedSlide.slideIds) {
        const processedIds = {};
        currentSelectedSlide.slideIds.forEach((slideId) => {
          processedIds[slideId] = true;
        });
        setProcessedSlideIds(processedIds);
      }
    } else {
      // CLASSIFY FLOW SPECIFIC LOGIC

      // Check if we have cached moduleIds for any slides (existing flow)
      const initialModuleIds = {};
      currentSelectedSlide.slideIds.forEach((slideId) => {
        if (moduleIdCache[slideId]) {
          initialModuleIds[slideId] = moduleIdCache[slideId];
        }
      });

      // If we have any cached moduleIds, update our state
      if (Object.keys(initialModuleIds).length > 0) {
        setModuleIds(initialModuleIds);

        // If we have a moduleId for the first slide, set it as the current moduleId
        const firstSlideId = currentSelectedSlide.slideIds[0];
        if (initialModuleIds[firstSlideId]) {
          setModuleId(initialModuleIds[firstSlideId]);
          setShowModuleAssembly(true);
        }
      }

      // Only fetch data for the first module initially (existing flow)
      if (numModules > 0) {
        const firstSlideId = currentSelectedSlide.slideIds[0];
        // Mark this slideId as being processed to prevent duplicate calls
        setProcessedSlideIds((prev) => ({
          ...prev,
          [firstSlideId]: true,
        }));
      }
    }
  };
  const transformApiDataToModuleFormat = (apiData, existingElements = {}) => {
    return {
      ...apiData,
      claims:
        apiData.claims?.map((claim) => {
          const existingClaim = existingElements.claims?.find(
            (c) => c.claimName === claim.claimName,
          );
          return {
            ...claim,
            mustUse: existingClaim?.mustUse || false,
          };
        }) || [],
      reusableTexts:
        apiData.reusableTexts?.map((text) => {
          const existingText = existingElements.reusableTexts?.find(
            (t) => t.reusableTextName === text.reusableTextName,
          );
          return {
            ...text,
            mustUse: existingText?.mustUse || false,
          };
        }) || [],
      components:
        apiData.components?.map((component) => {
          const existingComponent = existingElements.components?.find(
            (c) => c.componentDocNumber === component.componentDocNumber,
          );
          return {
            ...component,
            mustUse: existingComponent?.mustUse || false,
          };
        }) || [],
    };
  };

  const handleElementDeselect = (elementType, elementId) => {
    // Get the correct module ID based on the flow
    let currentModuleId;

    if (multiModuleCreation) {
      // FOR MULTI-MODULE CREATION: Use module index as key
      const multiModuleKey = `module_${currentModule}`;
      currentModuleId = moduleIds[multiModuleKey];

      if (!currentModuleId) {
        console.log(
          `Cannot remove element: Module ID not found for module ${currentModule}`,
        );
        return;
      }
    } else {
      // NORMAL FLOW: Use slideId to get moduleId
      const currentSlideId = getCurrentSlideId();
      if (!currentSlideId) {
        console.log("Cannot remove element: No current slide ID");
        return;
      }
      currentModuleId = moduleIds[currentSlideId];

      if (!currentModuleId) {
        console.log(
          "Cannot remove element: Module ID is not available for this slide",
        );
        return;
      }
    }

    // Check if this element was already saved to the database
    const isElementSaved = checkIfElementIsSaved(elementType, elementId);
    if (!isElementSaved) {
      // Still update local state even if not saved to API
      updateLocalElementState(elementType, elementId);
      return;
    }

    // Prepare the API endpoint based on element type
    let endpoint = "";
    let queryParam = "";

    switch (elementType) {
      case "claims":
        endpoint = `/api/modulems/v1/modules/${currentModuleId}/claims`;
        queryParam = `claimNames=${elementId}`;
        break;
      case "reusableTexts":
        endpoint = `/api/modulems/v1/modules/${currentModuleId}/reusableTexts`;
        queryParam = `reusableTextNames=${elementId}`;
        break;
      case "components":
        endpoint = `/api/modulems/v1/modules/${currentModuleId}/components`;
        queryParam = `componentNames=${elementId}`;
        break;
      default:
        console.log(`Unknown element type: ${elementType}`);
        return;
    }

    const fullEndpoint = `${endpoint}?${queryParam}`;

    // Call the removeElementFromModule API
    removeElementFromModule(
      currentModuleId,
      elementType,
      elementId,
      (response, error) => {
        if (response) {
          // Update local state after successful API call
          updateLocalElementState(elementType, elementId);
        } else {
          console.error(
            `Error removing ${elementType} with ID ${elementId}:`,
            error,
          );
          toast.error(
            <UnsuccessfulToastMessage
              message={
                error?.response?.data?.message ||
                `Failed to remove ${elementType}. Please try again.`
              }
              handleClose={() => toast.dismiss()}
            />,
            {
              autoClose: 5000,
              position: "top-right",
              closeButton: false,
            },
          );
        }
      },
      fullEndpoint,
    );
  };

  // Helper function to check if element is saved
  const checkIfElementIsSaved = (elementType, elementId) => {
    if (!moduleMetadata[currentModule - 1]?.savedElements) {
      return false;
    }

    const savedElements = moduleMetadata[currentModule - 1].savedElements;
    return savedElements[elementType]?.includes(elementId) || false;
  };

  // Helper to update local state after removal
  const updateLocalElementState = (elementType, elementId) => {
    setModuleMetadata((prev) => {
      const updatedMetadata = [...prev];
      if (updatedMetadata[currentModule - 1]) {
        // Update selectedElements (remove from current selection)
        updatedMetadata[currentModule - 1] = {
          ...updatedMetadata[currentModule - 1],
          selectedElements: {
            ...updatedMetadata[currentModule - 1].selectedElements,
            [elementType]: updatedMetadata[currentModule - 1].selectedElements[
              elementType
            ].filter((id) => id !== elementId),
          },
        };

        // Also update savedElements if it exists
        if (updatedMetadata[currentModule - 1].savedElements) {
          updatedMetadata[currentModule - 1] = {
            ...updatedMetadata[currentModule - 1],
            savedElements: {
              ...updatedMetadata[currentModule - 1].savedElements,
              [elementType]: updatedMetadata[currentModule - 1].savedElements[
                elementType
              ].filter((id) => id !== elementId),
            },
          };
        }
      }
      return updatedMetadata;
    });
  };

  // Handle element usage type change - call the toggleMustUse API
  const handleUsageTypeChange = (elementId, value, elementType, usageType) => {
    const currentSlideId = getCurrentSlideId();

    // Get the current slideId and its moduleId
    if (!currentSlideId) {
      console.log("Cannot change usage type: No current slide ID");
      return;
    }

    const currentModuleId = moduleIds[currentSlideId];

    // if (!currentModuleId) {
    //   console.log("Cannot change usage type: Module ID is not available for this slide");
    //   return;
    // }

    // Convert usage type to boolean for API call (must_use = true, optional = false)
    const mustUseValue = usageType?.veevaId === "must_use";

    // Update the moduleMetadata with the new mustuse value
    setModuleMetadata((prev) => {
      const updatedMetadata = [...prev];
      const moduleIndex = currentModule - 1;

      if (updatedMetadata[moduleIndex]) {
        const mapKey =
          elementType === "claims"
            ? "claimsMustuseMap"
            : elementType === "reusableTexts"
              ? "reusableTextsMustuseMap"
              : "componentMustuseMap";

        // Create a copy of the selectedElements
        const updatedSelectedElements = {
          ...updatedMetadata[moduleIndex].selectedElements,
          [mapKey]: {
            ...updatedMetadata[moduleIndex].selectedElements[mapKey],
            [String(elementId)]: mustUseValue,
          },
        };

        // Update the selectedElements in the module
        updatedMetadata[moduleIndex] = {
          ...updatedMetadata[moduleIndex],
          selectedElements: updatedSelectedElements,
        };
      }

      return updatedMetadata;
    });

    // Also update the moduleElements state to reflect the change in the UI
    setModuleElements((prev) => {
      // If we don't have elements for this module yet, return unchanged
      if (!prev[currentModule]) return prev;

      const updatedElements = { ...prev[currentModule] };

      // Update the mustUse property in the appropriate element array
      if (elementType === "claims" && updatedElements.claims) {
        updatedElements.claims = updatedElements.claims.map((claim) =>
          claim.claimName === elementId
            ? { ...claim, mustUse: mustUseValue }
            : claim,
        );
      } else if (
        elementType === "reusableTexts" &&
        updatedElements.reusableTexts
      ) {
        updatedElements.reusableTexts = updatedElements.reusableTexts.map(
          (text) =>
            text.reusableTextName === elementId
              ? { ...text, mustUse: mustUseValue }
              : text,
        );
      } else if (elementType === "components" && updatedElements.components) {
        updatedElements.components = updatedElements.components.map((comp) =>
          comp.componentDocNumber === elementId
            ? { ...comp, mustUse: mustUseValue }
            : comp,
        );
      }

      // Return the updated state
      const updatedState = {
        ...prev,
        [currentModule]: updatedElements,
      };

      // Also update the slideDataCache to persist changes
      const currentSlideId = getCurrentSlideId();
      if (currentSlideId && currentSelectedSlide?.assetId) {
        const cacheKey = getCacheKey(
          currentSelectedSlide.assetId,
          currentSlideId,
        );
        if (slideDataCache[cacheKey]) {
          slideDataCache[cacheKey] = updatedElements;
        }
      }

      return updatedState;
    });
  };

  // Add a function to handle navigation from CMSD preview back to module editor
  const handleCMSDEdit = (moduleIndex, editModuleId, editModuleData) => {
    history.push({
      pathname: routes.module,
      state: {
        moduleId: editModuleId,
      },
    });

    return;
  };

  const handleCancel = () => {
    // Clear local state but also clear moduleIds from cache to force API calls again
    setModuleId(null);

    // Reset UI state
    // setShowModuleAssembly(false);
    setIsBack(false);
    setNoElementsWarningShown(false);

    // Clear all selected elements from moduleElements
    setModuleElements({});

    // Reset module metadata completely
    setTotalModules(0);
    setCurrentModule(1);
    setModuleMetadata([]);

    // Clear processed slide IDs to force API calls again
    setProcessedSlideIds({});

    // Clear all cached data to force API calls again
    if (currentSelectedSlide) {
      if (currentSelectedSlide.assetId && currentSelectedSlide.slideIds) {
        // Clear moduleIds for all slides
        const clearedModuleIds = { ...moduleIds };
        currentSelectedSlide.slideIds.forEach((slideId) => {
          // Remove from moduleIds state
          delete clearedModuleIds[slideId];

          // Remove from global moduleIdCache
          delete moduleIdCache[slideId];

          // Clear cached slide data
          const cacheKey = getCacheKey(currentSelectedSlide.assetId, slideId);
          delete slideDataCache[cacheKey];

          // Also clear from window's global cache
          if (window.slideDataCache) {
            delete window.slideDataCache[cacheKey];
          }

          if (window.moduleIdCache) {
            delete window.moduleIdCache[slideId];
          }
        });

        // Update moduleIds state with cleared values
        setModuleIds(clearedModuleIds);
      }

      // Also clear cache by assetId if it exists
      if (
        currentSelectedSlide.assetId &&
        moduleIdCache[currentSelectedSlide.assetId]
      ) {
        delete moduleIdCache[currentSelectedSlide.assetId];
        if (window.moduleIdCache) {
          delete window.moduleIdCache[currentSelectedSlide.assetId];
        }
      }
    }

    // Close modal
    toggleModuleElementModal();
  };

  // const isLatestMessage =
  //   messages.filter((msg) => msg.responseType === "fullslide").slice(-1)[0]
  //     ?.id === messageId;

  // 1. Find the most recent "Edetail" proceed message
  const lastEdetailProceed = messages.findLast(
    (msg) => msg.sender === "user" && msg.proceedtype === "Edetail",
  );
  const shouldGreyOut =
    lastEdetailProceed &&
    messages.some(
      (msg) =>
        msg.sender === "bot" &&
        msg.responseType === "fullslide" &&
        msg.id < lastEdetailProceed.id &&
        msg.id === messageId,
    );

  // 3. Check if this is the latest fullslide message
  const isLatestFullslide =
    messages.filter((msg) => msg.responseType === "fullslide").slice(-1)[0]
      ?.id === messageId;

  const isFullslideMessage = messages.some(
    (msg) =>
      msg.id === messageId &&
      msg.responseType === "fullslide" &&
      msg.sender === "bot",
  );

  // Check if this message should be permanently greyed out
  const isPermanentlyGreyed = permanentlyGreyedOutIds.includes(messageId);

  // Apply greyout if ANY of these conditions are true
  const greyOutStyle = {
    opacity:
      isPermanentlyGreyed || shouldGreyOut || !isLatestFullslide ? 0.5 : 1,
    pointerEvents:
      isPermanentlyGreyed || shouldGreyOut || !isLatestFullslide
        ? "none"
        : "auto",
    filter:
      isPermanentlyGreyed || shouldGreyOut || !isLatestFullslide
        ? "grayscale(80%)"
        : "none",
    transition: "all 0.3s ease",
  };

  // useEffect to handle gryRetrivedSlideIds - ONE TIME ACTION
  useEffect(() => {
    if (gryRetrivedSlideIds) {
      // Find all fullslide bot messages
      const allFullslideMessages = messages.filter(
        (msg) => msg.responseType === "fullslide" && msg.sender === "bot",
      );

      // Extract just the IDs
      const fullslideMessageIds = allFullslideMessages.map((msg) => msg.id);
      // PERMANENTLY mark these messages as greyed out
      setPermanentlyGreyedOutIds(fullslideMessageIds);

      // Reset the flag (but styles remain applied)
      setTimeout(() => {
        setGryRetrivedSlideIds(false);
      }, 100);
    }
  }, [gryRetrivedSlideIds, messages, setGryRetrivedSlideIds]);

  // Reset permanently greyed out IDs when messages change significantly
  useEffect(() => {
    // Reset if messages array changes completely
    setPermanentlyGreyedOutIds([]);
  }, [messages.length]);

  const CompletedTick = () => {
    return <img src={success} alt="Success" width={12} />;
  };
  const CrossTick = () => {
    return <img src={crossicon} alt="Success" width={12} />;
  };

  const findScrollableParent = (element) => {
    let parent = element.parentElement;
    while (parent) {
      const hasScrollableContent = parent.scrollHeight > parent.clientHeight;
      const overflowY = window.getComputedStyle(parent).overflowY;
      const isScrollable =
        hasScrollableContent &&
        (overflowY === "auto" || overflowY === "scroll");

      if (isScrollable) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  };

  useEffect(() => {
    const shouldScroll = analyseModal || showModuleAssembly || showCMSDFlow;

    if (shouldScroll && listContentRef.current) {
      requestAnimationFrame(() => {
        const container = listContentRef.current;
        if (!container) return;

        const target =
          container.scrollHeight > container.clientHeight
            ? container
            : findScrollableParent(container);

        target &&
          target.scrollTo({
            top: target.scrollHeight,
            behavior: "smooth",
          });
      });
    }
  }, [analyseModal, showModuleAssembly, showCMSDFlow]);

  //for both flow navigation
  useEffect(() => {
    if (
      showModuleElementModal &&
      multiModuleCreation &&
      multipleModulesData.length > 0
    ) {
      const currentSlideId = getCurrentSlideId();

      if (currentSlideId && !processedSlideIds[currentSlideId]) {
        // Fetch module elements which will trigger metadata update
        // fetchModuleElements(currentModule, currentSlideId);
      } else if (multipleModulesData[currentModule - 1]) {
        // If already processed, ensure metadata is updated
        const moduleData = multipleModulesData[currentModule - 1];
        const transformedData = transformApiDataToModuleFormat(moduleData);

        // Update module elements if not already set
        if (!moduleElements[currentModule]) {
          setModuleElements((prev) => ({
            ...prev,
            [currentModule]: transformedData,
          }));
        }

        // Always update metadata when module changes
        updateModuleMetadataFromApiResponse(currentModule, transformedData);
      }
    }
  }, [
    currentModule,
    showModuleElementModal,
    multiModuleCreation,
    multipleModulesData,
  ]);

  const getCurrentModuleId = () => {
    if (multiModuleCreation) {
      const multiModuleKey = `module_${currentModule}`;
      return moduleIds[multiModuleKey] || null;
    } else {
      const currentSlideId = getCurrentSlideId();
      return moduleIds[currentSlideId] || null;
    }
  };

  return (
    <>
      <article
        ref={listContentRef}
        id="autotext"
        className={styles.respboxcontent}
      >
        {/* Step 1: Fetching elements */}
        <div className={styles.respboxslide} style={greyOutStyle}>
          <CompletedTick />
          <span className={styles.smallTextSlide}>
            Fetching the elements for module screen
          </span>
          {isLatestMessage &&
            (modulesPublished ||
            selectedSlide == null ||
            modalCompleted.elementModal ? (
              <span
                className={`${styles.viewSlideText} ${styles.disabledView}`}
              >
                View
              </span>
            ) : (
              <span
                onClick={() => {
                  setShowElementModal(true);
                  if (
                    multiModuleCreation &&
                    !analyseModal &&
                    !cancelGenerate &&
                    !showModuleAssembly &&
                    !showCMSDFlow
                  ) {
                    setGenerateMultiMod(true);
                    setTextShow(true);
                  }
                }}
                className={styles.viewSlideText}
              >
                View
              </span>
            ))}
        </div>

        {/* Step 2: Analyzing feasibility */}
        {analyseModal && (
          <div className={styles.respboxslide} style={greyOutStyle}>
            <CompletedTick />
            <span className={styles.smallTextSlide}>
              Analysing the module creation feasibility
            </span>
            {isLatestMessage &&
              (modulesPublished ||
              selectedSlide == null ||
              modalCompleted.analyseModal ? (
                <span
                  className={`${styles.viewSlideText} ${styles.disabledView}`}
                >
                  View
                </span>
              ) : (
                <>
                  <span
                    onClick={() => setShowAnalyseModal(true)}
                    className={styles.viewSlideText}
                  >
                    {multiModuleCreation ? "" : "View"}
                  </span>
                </>
              ))}
          </div>
        )}

        {multiModulesLoading && isLatestMessage ? (
          <OneByFourLoader
            key={`loader-${messageId}-${multiModulesLoading}`}
            ismultiloader={true}
            loadingSteps={[
              { text: "Model analysing the elements..." },
              {
                text: "Putting together all the elements for the module...",
              },
              { text: "Fetching relevant metadata..." },
              { text: "Fetching images for all the modules..." },
            ]}
          />
        ) : null}

        {multiModulesError && (
          <div className={styles.respboxslide} style={greyOutStyle}>
            <CrossTick />
            <span className={styles.smallTextSlide}>
              {multiModulesError === "NO_MODULES_FOUND"
                ? "No recommended modules could be created for the selected slides."
                : "Failed to create modules. Please try again."}
            </span>
          </div>
        )}

        {/* Step 3: Module assembly */}
        {showModuleAssembly && !abortModules && (
          <div className={styles.respboxslide} style={greyOutStyle}>
            <CompletedTick />
            <span className={styles.smallTextSlide}>
              Assembling module, applying intra-modular business rule, module
              metadata generation
            </span>
            {isLatestMessage &&
              (modulesPublished ||
              selectedSlide == null ||
              modalCompleted.moduleAssembly ? (
                <span
                  className={`${styles.viewSlideText} ${styles.disabledView}`}
                >
                  View
                </span>
              ) : (
                <span
                  onClick={() => setShowModuleElementModal(true)}
                  className={styles.viewSlideText}
                >
                  View
                </span>
              ))}
          </div>
        )}

        {/* Step 4: Finalizing module */}
        {showCMSDFlow && (
          <div className={styles.respboxslide} style={greyOutStyle}>
            <CompletedTick />
            <span className={styles.smallTextSlide}>Finalising module</span>
            {isLatestMessage &&
              (modulesPublished ||
              selectedSlide == null ||
              modalCompleted.cmsdModal ? (
                <span
                  className={`${styles.viewSlideText} ${styles.disabledView}`}
                >
                  View
                </span>
              ) : (
                <span
                  onClick={() => setShowCmsd(true)}
                  className={styles.viewSlideText}
                >
                  View
                </span>
              ))}
          </div>
        )}
      </article>
      <ElementPreviewSlides
        show={showElementModal}
        onClose={() => {
          setShowElementModal(false);
          setModalCompleted((prev) => ({ ...prev, elementModal: true }));
        }}
        setAnalyseModal={setAnalyseModal}
        modulesData={modulesData}
        messageId={messageId}
        selectedSlide={selectedSlide}
      />

      {!multiModuleCreation && (
        <AnalysePreviewSlides
          show={showAnalysetModal && !multiModuleCreation}
          onClose={() => {
            handleCloseAnalyseModal();
            setModalCompleted((prev) => ({ ...prev, analyseModal: true }));
          }}
          messageId={messageId}
          slideCount={slideCount}
          slides={fullSlideData.slides}
          setAnalyseModal={setAnalyseModal}
          setShowCmsddata={() => null}
          selectedSlide={selectedSlide}
          modulesData={modulesData}
          setShowModuleAssembly={setShowModuleAssembly}
        />
      )}

      {showAnalysetModal && multiModuleCreation && (
        <MultiAnalysePreviewSlides
          selectedSlide={selectedSlide}
          show={multiModuleCreation}
          onClose={() => {
            handleCloseAnalyseModal();
            setShowAnalyseModal(false);
            setShowModuleAssembly(false);
            setModalCompleted((prev) => ({ ...prev, analyseModal: true }));
          }}
          onGoAhead={() => {
            handleCloseAnalyseModal();
            setShowAnalyseModal(false);
            setShowModuleAssembly(true);
          }}
          userCollectedMeta={userCollectedMeta}
        />
      )}

      <GenarateCMSD
        show={showCMSD}
        onClose={() => {
          setShowCmsd(false);
          setMultiModuleCreation(false);
          setModalCompleted((prev) => ({ ...prev, cmsdModal: true }));
        }}
        setShowCmsd={setShowCmsd}
        setSendCMSD={setSendCMSD}
        moduleIds={moduleIds}
        selectedModules={selectedModules}
        createdModules={createdModules}
        selectedSlide={currentSelectedSlide}
        onEditModule={handleCMSDEdit}
        edetailDetails={edetailDetails}
        multiModuleCreation={multiModuleCreation}
        multipleModulesData={multipleModulesData}
      />

      <ProceedCMSD show={sendCMSD} onClose={() => setSendCMSD(false)} />

      <ModuleElementModal
        key={currentSelectedSlide?.slideIds[currentModule - 1]}
        isOpen={showModuleElementModal}
        elementsLoading={
          elementsLoading || (multiModuleCreation && multiModulesLoading)
        }
        onClose={() => {
          toggleModuleElementModal();
          setModalCompleted((prev) => ({ ...prev, moduleAssembly: true }));
        }}
        currentModule={currentModule}
        totalModules={totalModules}
        onBack={handleBack}
        onCancel={handleCancel}
        onNext={handleNext}
        buttonLoading={buttonLoading}
        onGenerateCMSD={handleGenerateCMSD}
        moduleMetadata={moduleMetadata.find(
          (meta) => meta.id === currentModule,
        )}
        elements={moduleElements[currentModule] || {}}
        onMetadataChange={handleMetadataChange}
        metaDataDropDownList={[]}
        onUsageTypeChange={handleUsageTypeChange}
        onElementDeselect={handleElementDeselect}
        assetId={currentSelectedSlide}
        pageId={currentSelectedSlide?.slideIds[currentModule - 1]}
        countryNameUI={countryNameUI}
        moduleId={getCurrentModuleId()}
        selectedSlide={selectedSlide}
        transformSelectedSlide={transformSelectedSlide}
        userCollectedMeta={userCollectedMeta}
        multiModuleCreation={multiModuleCreation}
        multipleModulesData={multipleModulesData}
        selectedModules={selectedModules}
        createdModules={createdModules}
        onModuleSelectionChange={handleModuleSelectionChange}
        onModuleNavigate={handleModuleNavigate}
        slideNames={currentSelectedSlide?.slidenums || []}
        showAllPreview={showAllPreview}
        missingMetadataModules={missingMetadataModules}
        showMissingMetadataPopup={showMissingMetadataPopup}
        setShowMissingMetadataPopup={setShowMissingMetadataPopup}
      />

      {/* multi cration flow no datafound multimodal popup*/}

      <CustomModal
        displayModal={showErrorModal}
        hideModal={() => setShowErrorModal(false)}
        size="sm"
        dilogClassName="alertModalSmall"
        backdrop={false}
      >
        <ConfirmationPopup
          title={
            multiModulesError === "NO_MODULES_FOUND"
              ? "No recommended modules"
              : "Error occurred"
          }
          isCancelNeeded={false}
          text={
            multiModulesError === "NO_MODULES_FOUND"
              ? "No recommended modules could be created for the selected slides."
              : "An error occurred while creating modules. Please try again."
          }
          handleConfirm={() => {
            setShowErrorModal(false);
            if (setTextShow) setTextShow(false);
            if (setCancelGenerate) {
              setCancelGenerate(false);
              setGoforGenerate(true);
              setTextShow(true);
              setShowNewBubble(false);
            }
            setTextShow(true);
            setRestartModules(true);
            setShowNewBubble(false);
          }}
          primaryButtonTitle="OK, GOT IT"
        />
      </CustomModal>
    </>
  );
};
